import type { PublicPlayer } from '@/api/generated/game';

export interface SeatPickerProps {
  title: string;
  players: PublicPlayer[];
  onPick: (seat: number) => void;
  /** Отсутствует у обязательного выбора: из `awaiting_choice` выхода нет. */
  onCancel?: () => void;
  empty?: string;
}

/**
 * Выбор места: адресат карточки (`pick_target`) и жертва спасателя
 * (`use_rescuer`). Кого можно выбирать, решает вызывающий — правила у сервера,
 * здесь только список и тап.
 */
export function SeatPicker({ title, players, onPick, onCancel, empty }: SeatPickerProps) {
  return (
    <div className="border-2 border-line bg-line">
      <p className="bg-panel px-4 py-3 text-meta uppercase tracking-widest text-mute">{title}</p>

      <div className="mt-rule flex flex-col gap-rule">
        {players.map((player) => (
          <button
            key={player.id}
            type="button"
            onClick={() => onPick(player.seat)}
            className="flex h-tap items-center bg-panel px-4 text-left font-display text-row text-ink"
          >
            {player.name}
          </button>
        ))}

        {players.length === 0 && (
          <p className="bg-panel px-4 py-4 text-base text-mute">{empty ?? 'Некого выбрать.'}</p>
        )}

        {onCancel && (
          <button
            type="button"
            onClick={onCancel}
            className="flex h-tap items-center bg-panel px-4 text-left text-meta uppercase tracking-widest text-mute"
          >
            Отмена
          </button>
        )}
      </div>
    </div>
  );
}
